import { produce } from 'immer';
import {
  CLEAR_COLLECTED_ORDER,
  CLEAR_PLACE_COLLECTED_ORDER,
  PLACE_COLLECTED_ORDER,
  PLACE_COLLECTED_ORDER_FULFILLED,
  PLACE_COLLECTED_ORDER_REJECTED,
  TOGGLE_COLLECTED_ORDER,
  UPDATE_COLLECTED_ORDER,
} from 'b2b-apps/shop/collectedOrder/redux/actionTypes';
import { CollectedOrderActions, CollectedOrderState } from 'b2b-apps/shop/collectedOrder/redux/types';
import { RemoteRecordData } from 'b2b-apps/shop/common/redux/RemoteRecordData';
import { CollectedOrderDataType } from 'b2b-common/core/collectedOrder/CollectedOrder.types';

const initialData: CollectedOrderDataType = {
  licenseHolder: {
    hasError: true,
    licenseHolder: '',
  },
  references: {
    order: '',
    sales: '',
  },
};

const initialState: CollectedOrderState = {
  data: initialData,
  isEnabled: null,
  place: RemoteRecordData.getDefault(),
};

const reducer = (
  state: CollectedOrderState = initialState,
  action: CollectedOrderActions,
): CollectedOrderState => produce(state, (draft: CollectedOrderState) => {
  switch (action.type) {
    case CLEAR_COLLECTED_ORDER:
      draft.data = initialData;
      draft.isEnabled = null;
      break;

    case CLEAR_PLACE_COLLECTED_ORDER:
      draft.place = RemoteRecordData.getDefault();
      break;

    case PLACE_COLLECTED_ORDER:
      draft.place = RemoteRecordData.init();
      break;

    case PLACE_COLLECTED_ORDER_FULFILLED:
      draft.place = RemoteRecordData.fulfill(action.payload.data);
      break;

    case PLACE_COLLECTED_ORDER_REJECTED:
      draft.place = RemoteRecordData.reject(action.payload.error);
      break;

    case TOGGLE_COLLECTED_ORDER:
      draft.isEnabled = action.payload.isEnabled !== undefined
        ? action.payload.isEnabled
        : !state.isEnabled;
      break;

    case UPDATE_COLLECTED_ORDER:
      draft.data = action.payload.data;
      break;

    default:
      return state;
  }
});

export { reducer };
